import React, { useContext } from 'react';
import { string, arrayOf, func, bool } from 'prop-types';
import classNames from 'classnames/bind';
import { ExperienceContext } from '@thd-nucleus/experience-context';
import { Drawer, DrawerItem, DrawerNav } from '@thd-olt-component-react/drawer';
import { QueryProvider } from '@thd-nucleus/data-sources';
import { ProductPod } from '@thd-olt-component-react/product-pod';
import { CarouselHeader } from '../core/CarouselHeader';
import { getSkippers } from '../utils/helpers';
import { supplementalRecsdataModel } from '../dataModel';
import styles from './SupplementalRecs.module.scss';

const cx = classNames.bind(styles);

const SupplementalRecsPods = ({
  productsData, schemaName, storeId, zipCode, handleViewDetailsClick, podTitle, isDrawerOpen
}) => {

  const { channel } = useContext(ExperienceContext);
  const isMobile = channel !== 'desktop';
  const drawerWidth = isMobile ? 100 : 500;
  const defaultVariables = {
    storeId,
    zipCode,
    ...getSkippers({})
  };
  const title = podTitle || 'Shop the Look';
  return (
    <>
      {
        productsData?.length
        && (
          <Drawer
            id={schemaName}
            open={isDrawerOpen}
            isMobile={isMobile}
            position="right"
            initialItem="recommendations-quick-view"
            maxSize={drawerWidth}
            onClose={handleViewDetailsClick}
          >
            <DrawerItem name="recommendations-quick-view">
              <DrawerNav>
                <CarouselHeader title={title} />
              </DrawerNav>
              <div className={cx('supplemental-recs__drawer-item-wrapper')}>
                <QueryProvider
                  dataSource={schemaName}
                  cacheKey={`${schemaName}-supplemental-recs-products`}
                  defaultVariables={defaultVariables}
                >
                  {
                    productsData.map((prod, idx) => {
                      return (
                        <ProductPod
                          key={prod?.product.itemId}
                          itemId={prod?.product.itemId}
                          brandTitleMaxLine={3}
                          podType="mini"
                          showDisabledATC
                          hideSavingsText
                          storeId={storeId}
                          zipCode={zipCode}
                          position={idx}
                          sharedSection="multi-sku"
                          miniOptions={{
                            onAction: () => {},
                            hideCaret: true,
                            ctaNoPadding: true
                          }}
                        />
                      );
                    })
                  }
                </QueryProvider>
              </div>
            </DrawerItem>
          </Drawer>
        )
      }
    </>
  );
};

SupplementalRecsPods.propTypes = {
  isDrawerOpen: bool,
  productsData: arrayOf(Object),
  storeId: string.isRequired,
  zipCode: string.isRequired,
  schemaName: string.isRequired,
  handleViewDetailsClick: func.isRequired,
  podTitle: string
};

SupplementalRecsPods.defaultProps = {
  isDrawerOpen: false,
  productsData: null,
  podTitle: null
};

SupplementalRecsPods.dataModel = supplementalRecsdataModel;
SupplementalRecsPods.displayName = 'SupplementalRecs';

export { SupplementalRecsPods };
